$(document).ready(function () {
    $("body").off("change", "[data-dropdown-trigger='makeandmodeldropdown']");
    $("body").on("change", "[data-dropdown-trigger='makeandmodeldropdown']", function () {

        var data = this.dataset.bindingControlName;
        {

            var brandValuefrom = this.selectedOptions[0].id;
            var brandvalueindropdown = this.selectedOptions[0].dataset.brandId;
            var queryParameters = '';
            var apiUrl = '';
            {
                if (brandValuefrom != 'undefined' && brandValuefrom != '') {
                    queryParameters = { brand: brandValuefrom, vehicleName: this.value }
                    apiUrl = '/api/forms/GetVehicleCategory';
                }
                else {
                    queryParameters = { brand: brandvalueindropdown, vehicleName: 'null' };
                    apiUrl = '/api/forms/GetVehicleCategory';
                    console.log(queryParameters);
                }
            }
            var newhtml = '';
            if (typeof $("[data-sc-field-name='" + data + "']")[0][0] != 'undefined') {
                var defaultValue = $("[data-sc-field-name='" + data + "']")[0][0].value;
                newhtml += '<option selected="" disabled="" data-brand-id="default">' + defaultValue + '</option>';
            }
            if (brandvalueindropdown != "default") {
                $.ajax({
                    type: "GET",
                    url: apiUrl,
                    data: queryParameters,
                    dataType: 'text',
                    contentType: 'application/json',
                    success: function (response) {

                        var html = '';

                        var jsonResponse = $.parseJSON(response);
                        for (var i = 0; i < jsonResponse.length; i++) {
                            if (brandValuefrom != 'undefined' && brandValuefrom != '') {
                                html += '<option value="' + jsonResponse[i].VehiceVariant + '">' + jsonResponse[i].VehiceVariant + '</option>';
                            }
                            else {
                                html += '<option id="' + brandvalueindropdown + '" value="' + jsonResponse[i].VehicleModel + '">' + jsonResponse[i].VehicleModel + '</option>';

                            }
                        }

                        $("[data-sc-field-name='" + data + "']").empty();
                        newhtml += html;
                        $("[data-sc-field-name='" + data + "']").append(newhtml);
                        $("[data-sc-field-name='" + data + "']").trigger("change")


                    }
                });
            }
            else {
                $("[data-sc-field-name='" + data + "']").empty();

                $("[data-sc-field-name='" + data + "']").append(newhtml);
                $("[data-sc-field-name='" + data + "']").trigger("change")
            }
        }
    });
    $("body").unbind("change", "[data-dropdown-trigger='makeandmodeldropdown']");
});